<modal-panel title="Error Logs Information" data-testid="error-logs-details-modal-panel" (close)="close()">
  <ng-container data-testid="error-logs-details-modal-content">
    <mat-card class="mat-elevation-z8">
      <mat-card-content>
        <mat-grid-list [cols]="1" gutterSize="10px" rowHeight="90">
          @if (details()) {
            <mat-grid-tile>
              <read-only-form-field title="Name" value="{{details()!.name}}"/>
            </mat-grid-tile>
            <mat-grid-tile>
              <read-only-form-field title="Timestamp" value="{{details()!.timestamp}}"/>
            </mat-grid-tile>
            <mat-grid-tile>
              <read-only-form-field
                title="Url"
                value="{{details()!.requestUrl}}"
                [matTooltip]="details()!.requestUrl"/>
            </mat-grid-tile>
            <mat-grid-tile>
              <read-only-form-field title="Status Code" value="{{details()!.statusCode}}"/>
            </mat-grid-tile>
            <mat-grid-tile>
              <read-only-form-field title="Http Method" value="{{details()!.httpMethod}}"/>
            </mat-grid-tile>
            <mat-grid-tile>
              <read-only-form-field title="Error Message" value="{{details()!.errorMessage}}"/>
            </mat-grid-tile>
          }
        </mat-grid-list>
      </mat-card-content>
    </mat-card>

    @if (payloadDetails()) {
      <h2 style="margin-top: 1rem">Payload Details</h2>
      <mat-card class="mat-elevation-z8">
        <mat-card-content>
          <mat-grid-list [cols]="1" gutterSize="10px" rowHeight="90">
            <mat-grid-tile>
              <read-only-form-field title="Status" value="{{payloadDetails()!.status}}"/>
            </mat-grid-tile>
          </mat-grid-list>
          <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
            <mat-label>Detail</mat-label>
            <textarea
              matInput
              [value]="getDetailText()"
              readonly
              rows="3"
              class="detail-textarea">
            </textarea>
            <mat-icon matSuffix>edit_off</mat-icon>
          </mat-form-field>
          @for (item of payloadDetails()!.payloadDetailsData; track $index) {
            <mat-grid-list [cols]="1" gutterSize="10px" rowHeight="90">
              <mat-grid-tile>
                <read-only-form-field title="{{item.label}}" value="{{item.value}}"/>
              </mat-grid-tile>
            </mat-grid-list>
          }
        </mat-card-content>
      </mat-card>
    }
  </ng-container>

  <ng-container data-testid="error-logs-details-modal-footer" modalPanelFooter>
    <button data-testid="error-logs-details-modal-close-button" mat-raised-button color="primary" (click)="close()">Close</button>
  </ng-container>
</modal-panel>
